import { Injectable } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Observable, from, of, Subject, BehaviorSubject } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
import { catchError, exhaustMap, map, mergeMap, switchMap, filter, first, concatMap, take } from 'rxjs/operators';
import { Router } from '@angular/router';
import { fromPromiseToObservable } from '../utils';
import { IUser } from '../model/User.model';
import { ICustomer } from 'src/app/register/model/customer.model';

// custom user interface
interface User {
  name: string;
  // uid: string;
  // email: string;
  // photoURL: string;
  // catchPhrase?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AuthService {
  user: Observable<User> = null;
  authState: Observable<firebase.User> = null;

  userUid: string;

  constructor(
    public afAuth: AngularFireAuth,
    private afs: AngularFirestore
  ) {
    // this.userProfile = new BehaviorSubject<IUser>({} as IUser);
    // this.afAuth.authState
    //   .pipe(
    //     filter(user => {
    //       return user !== null;
    //     }),
    //     map((user) => user),
    //     switchMap(user => {
    //       if (user) {
    //         return this.afs.doc<IUser>(`users/${user.uid}`).snapshotChanges();
    //       }
    //     })
    //   )
    //   .subscribe(user => {
    //     this.userProfile.next(user.payload.data());
    //     console.log('userProfile', user.payload.data());
    //   });
  }

  userIsStaffGuard() {
    return this.afAuth.authState
      .pipe(
        map(user => user),
        switchMap(user => {
          return this.getCustomerUserProfileByUid(user.uid);
        }),
        first(),
      );
  }

  getCustomerUserProfileByUid(userUid: string) {
    return this.afs.doc<ICustomer>(`users/${userUid}`)
      .snapshotChanges()
      .pipe(
        map(userRef => {
          const customer = {
            ...userRef.payload.data(),
            uid: userUid
          };
          return customer;
        }),
      );
  }

  userIsLoggedIn() {
    return this.afAuth.authState
      .pipe(
        map(authState => {
          if (authState) {
            this.userUid = authState.uid;
          }
          return !!authState;
        }),
        first(),
      );
  }

  logInAndGetUserProfile(email: string, password: string) {
    return fromPromiseToObservable(
      this.afAuth.auth.signInWithEmailAndPassword(email, password)
    ).pipe(
      map(user => user.user.uid),
      switchMap(uid => {
        return this.getUserProfileOnce(uid);
      })
    );
  }

  getUserProfileOnce(uid: string) {
    return this.afs.doc<IUser>(`users/${uid}`)
      .snapshotChanges()
      .pipe(
        map(userRef => {
          return userRef.payload.data();
        }),
        take(1)
      );
  }

  getCustomerProfile() {
    return this.afs.doc<ICustomer>(`users/${this.userUid}`)
      .snapshotChanges()
      .pipe(
        map(userRef => {
          const customer = {
            ...userRef.payload.data(),
            uid: this.userUid
          };
          return customer;
        }),
      );
  }

  getUserProfile() {
    return this.afs.doc<IUser>(`users/${this.userUid}`)
      .snapshotChanges()
      .pipe(
        map(userRef => {
          return userRef.payload.data();
        }),
      );
  }

  resetPassword(email: string) {
    return fromPromiseToObservable(
      this.afAuth.auth.sendPasswordResetEmail(email)
    );
  }

  signIn(email: string, password: string) {
    return fromPromiseToObservable(
      this.afAuth.auth.signInWithEmailAndPassword(email, password)
    );
  }

  // Returns true if user is logged in
  get isAuthenticated(): boolean {
    console.log('AUTHSTATE', this.authState);
    return this.user !== null;
  }

  getAuthState() {
    return this.afAuth.authState;
  }

  currentUserObservable(): Observable<firebase.User> {
    return this.afAuth.authState
      .pipe(
        map(user => user),
        first() // Stop stream from firebase
      );
  }

  logout() {
    this.afAuth.auth.signOut();
  }
}
